import { HTMLInputTypeAttribute, ReactNode, Ref } from "react";
import { Property } from "csstype";

export interface BaseProps<T extends HTMLElement> {
  'aria-label'?: string, 
	className?: string,
	id?: string,
  ref?: Ref<any>,
  sx?: SxProps,
  onClick?: React.MouseEventHandler<T>,
	onMouseDown?: React.MouseEventHandler<T>,
  onChange?: React.ChangeEventHandler<T>,
	onFocus?: React.FocusEventHandler<T>,
	onBlur?: React.FocusEventHandler<T>
}

export interface ChildrenProps<T extends HTMLElement> extends BaseProps<T> {
  children?: ReactNode
}

export interface InputProps<R extends HTMLElement, T extends HTMLElement> extends Omit<BaseProps<T>, 'onChange' | 'onFocus' | 'onBlur'> {
  fullWidth?: boolean,
  inputRef?: Ref<any>,
  label?: string,
  required?: boolean,
  type?: HTMLInputTypeAttribute,
  value?: any,
  onChange?: React.ChangeEventHandler<R>,
	onFocus?: React.FocusEventHandler<R>,
	onBlur?: React.FocusEventHandler<R>
}

export type SxProps = {
  backgroundColor?: Property.BackgroundColor
}

export function appendClassName(
  componentClassName: string,
  additionalClassName: string | undefined) 
: string {
  return `${componentClassName}${additionalClassName ? ` ${additionalClassName}` : ''}`;
}

export type AlignItemsTypes = 'center'
| 'end'
| 'flex-end'
| 'flex-start'
| 'inherit'
| 'initial'
| 'left'
| 'normal'
| 'revert'
| 'revert-layer'
| 'right'
| 'space-around'
| 'space-between'
| 'space-evenly'
| 'start'
| 'stretch'
| 'unset'

export type JustifyContentTypes = 'center'
| 'end'
| 'flex-end'
| 'flex-start'
| 'inherit'
| 'initial'
| 'left'
| 'normal'
| 'revert'
| 'revert-layer'
| 'right'
| 'space-around'
| 'space-between'
| 'space-evenly'
| 'start'
| 'stretch'
| 'unset'

export type DisplayTypes = 'inline'
| 'block'
| 'contents'
| 'flex'
| 'grid'
| 'inline-block'
| 'inline-flex'
| 'inline-grid'
| 'inline-table'
| 'list-item'
| 'run-in'
| 'table'
| 'table-caption'
| 'table-column-group'
| 'table-header-group'
| 'table-footer-group'
| 'table-row-group'
| 'table-cell'
| 'table-column'
| 'table-row'
| 'none'
| 'initial'
| 'inherit'

export type BreakpointTypes = 'xl'
| 'lg'
| 'md'
| 'sm'
| 'xs'

export type LiteralStringOrArrayOfLiteralStrings<T> = T | Array<T>